<template>
  <a-modal
    title="数据导入"
    :visible="visible"
    :mask-closable="false"
    :width="450"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button @click="handleCancel">
        关闭
      </a-button>
    </template>
    <div class="a-import">
      <a-row :gutter="16">
        <a-col :span="6">
          点击查看模板:
        </a-col>
        <a-col :span="6">
          <a :href="importURL.VoucherTaxIncludedURL">模板</a>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="6">
          <hy-upload
            ref="fileUpload"
            :accept="'.xls,.xlsx'"
            :upload-params="{ code: 'creative-platform', app: 'op'}"
            :is-show-list="false"
            @success="successEvent"
            @uploadChange="uploadChange"
          >
            <template
              v-if="importLoading"
              slot="content"
            >
              <!-- 自定义样式 -->
              <a-button>
                <a-icon type="loading" /> 上传文件
              </a-button>
            </template>
          </hy-upload>
        </a-col>
      </a-row>
      <a
        v-if="hasUploaded"
        :href="uploadedURL"
      >{{ uploadedName }}</a>

      <div v-if="lopMessageVisible">
        上传进度：{{ lopMessage }}
      </div>

      <div v-if="!isStandard">
        <a-table
          :columns="columns"
          :data-source="dataSource"
          :pagination="false"
          :row-key="(item, index) => index"
        />
      </div>
    </div>
  </a-modal>
</template>

<script>
import { importURL } from '@/constants/common'
import { importTaxIncome, importTaxIncomeProgress } from '@/api/vocherIncome.js'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      columns: [
        {
          title: '行数',
          dataIndex: 'row',
          key: 'row'
        },
        {
          title: '未通过原因',
          dataIndex: 'message',
          key: 'message'
        }],
      dataSource: [],
      importURL,
      importVisible: false,
      hasUploaded: false,
      uploadedName: '',
      uploadedURL: '',
      isStandard: true,
      importLoading: false,
      lopMessage: undefined,
      lopMessageVisible: false
    }
  },
  methods: {
    handleCancel () {
      this.$emit('importCancel')
      this.hasUploaded = false
      this.isStandard = true
      this.lopMessageVisible = false
    },
    successEvent (msg) { // 上传成功文件回调
      this.importLoading = true
      importTaxIncome({
        fileUrl: msg[0].url
      }).then((data) => {
        this.importLoading = false
        if (data.length > 0) {
          this.dataSource = data
          this.isStandard = false
        }
      })
      this.confirmImport()
      this.uploadedName = msg[0].key
      this.uploadedURL = msg[0].url
      this.hasUploaded = true
    },
    uploadChange (value) {
      if (!value) {
        this.importLoading = false
      }
    },
    confirmImport () {
      const timer = setInterval(async () => {
        this.lopMessageVisible = true
        this.loopResult(timer)
      }, 1000)
    },
    loopResult (timer) {
      // ajax请求
      importTaxIncomeProgress().then((data) => {
        if (data.res || !data.isHandle || !timer) {
          clearInterval(timer)
          if (data.res) {
            this.$emit('importOk')
            this.handleCancel()
          }
        }
        this.lopMessage = data.progress
      })
    }
  }
}
</script>
<style lang="less" scoped>
.a-import {
  /deep/.ant-row {
    margin: 20px;
  }
}
</style>
